import rpc from '@square/dashboard-utilities/clients/rpc';
import { DefaultDeviceProfileService } from '@square/dashboard-protos/models/squareup/client/device_settings/device_profile';
export default DefaultDeviceProfileService.create(rpc());